import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface CreateDispositionParams {
  dispositionDescription: string;
  dispositionCode: string;
}

interface CreateDispositionResponse {
  references: fhirTypes.DocumentReference[];
}

export const useCreateDisposition = ({
  encounterId,
  carePlanId,
}: {
  encounterId: string;
  carePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<CreateDispositionResponse, CreateDispositionParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.CREATE({
          patientId,
          encounterId,
          carePlanId,
        }),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/charting/careplan/${carePlanId}/disposition`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId,
              },
            ),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
